import React, {PureComponent} from 'react';
import {Col, Button, Row, Card, CardBody} from 'reactstrap';
import TextSearch from '../../../components/TextSearch'
import * as http from '../../../modules/http';
import LoadingProgress from '../../../components/LoadingProgress';
import Select from '../../../components/Select';
import {
    prize_update_field,
    prize_insert, prize_update
} from '../../../redux/actions/PrizeActions';
import Alert from '../../../components/Alert';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as TextManager from "../../../modules/languages/TextManager";


const goalTypeArr = [ //{label: '', value: 0},
    {label: 'שבוע', value: 1},
    {label: 'שבועיים', value: 2},
    {label: 'חודש', value: 3}];

class EditPrizeForm extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false,
            showPassword: false,
            changePassword: false
        };
    }


    editValue = (label, newValue) => {
        this.props.dispatch(prize_update_field(label, newValue));

        if(label === 'storeId') {
            let store = this.props.utilsData.data.stores.find(a => a.value === parseInt(newValue));

            if(store !== undefined) {
                this.props.dispatch(prize_update_field('storeName', store.label));
                this.setState({storeName: store.label});
            }
        }
    };

    savePrize = () => {

        const isAdding = (this.props.prizeInEdit.id === 0);

        //validation
        if (isAdding) {
            if (!this.props.prizeInEdit.storeId || this.props.prizeInEdit.storeId === 0) {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectUsername});
                return;
            }
        }
        else {
            if (!this.props.prizeInEdit.goal || this.props.prizeInEdit.goal === 0) {
                this.setState({warning: "Please select Goal"});
                return;
            }

            if (!this.props.prizeInEdit.prize || this.props.prizeInEdit.prize === '') {
                this.setState({warning: "Please select Prize"});
                return;
            }
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            id: this.props.prizeInEdit.id,
            storeId: parseInt(this.props.prizeInEdit.storeId),
            storeName: this.props.prizeInEdit.storeName,
            soldNum: 0,
            goal: parseInt(this.props.prizeInEdit.goal),
            prize: this.props.prizeInEdit.prize,
            startDay: this.props.prizeInEdit.startDay,
            endDay: this.props.prizeInEdit.endDay,
            managerId: 0,
            managerName : "",
            comment: this.props.prizeInEdit.comment,
            goalType: parseInt(this.props.prizeInEdit.goalType)
        };

        var requestUrl = 'prize/update';
        if (isAdding) {
            requestUrl = 'prize/new'
        }
        http.postToServer(
            requestUrl,
            storeData,
            (response) => {

                this.setState({saving: false, error: false});

                if (isAdding) {
                    this.props.dispatch(prize_insert(response.data));
                }
                else {
                    this.props.dispatch(prize_update(response.data, this.props.day));
                }

                //this.props.dispatch(fetchUserDataIfNeeded(true));
                this.props.onClose();

            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})

            }
        );
    };

    render() {

        const isAdding = this.props.prizeInEdit.id === 0;

        //console.log(this.props.prizeInEdit)

        let stores = [];
        let filtered = [];

        if(this.props.stores) {
            filtered = this.props.stores.filter(e => e.storeId === 0 || e.storeId === undefined);
        }

        for(let indx in filtered){
            stores.push({value: filtered[indx].id, label: filtered[indx].name});
        }

        //console.log(this.props.prizeInEdit.goalType)

        return (

            <Row style={{flexDirection: "row-reverse"}}>
                <Col md={8}>
                    <Card>
                        <CardBody>
                            <div className='card__title'>

                                {isAdding &&
                                    <h5 className='bold-text'>{TextManager.getCurrentTextResource().Text.addStore}</h5>
                                }

                                {!isAdding &&
                                    <h5 className='bold-text'>{TextManager.getCurrentTextResource().Text.editStore}</h5>
                                }

                            </div>
                            <form className='form form--horizontal'>

                                {isAdding && <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.storeId}</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.prizeInEdit.storeId} noSpace
                                                    onChange={(value) => this.editValue('storeId', value)}/>
                                    </div>
                                </div>}

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.storeName}</label>
                                    <div className='form__form-group-field'>
                                        <input
                                            dir={"auto"}
                                            style={{backgroundColor: '#F0F8FF'}}
                                            value={this.props.prizeInEdit.storeName}
                                            name="storeName"
                                            type="text"
                                            disabled={true}
                                            onChange={(event) =>
                                                this.editValue('storeName', event.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>סוג היעד</label>
                                    <div className='form__form-group-field'>
                                        <Select
                                            name='select'
                                            style={this.props.prizeInEdit.startDay === '' ? {} : {backgroundColor: '#F0F8FF'}}
                                            value={this.props.prizeInEdit.goalType}
                                            type={"select"}
                                            select
                                            disabled={this.props.prizeInEdit.startDay !== ''}
                                            options={goalTypeArr}
                                            onChange={(value) => this.editValue('goalType',  value.value)}
                                        >
                                        </Select>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>יעד ל{this.props.prizeInEdit.goalType === 0 ? '' : goalTypeArr.find(e => e.value === this.props.prizeInEdit.goalType).label}</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.prizeInEdit.goal}
                                                    style={this.props.prizeInEdit.startDay === '' ? {} : {backgroundColor: '#F0F8FF'}}
                                                    disabled={this.props.prizeInEdit.startDay !== ''}
                                                    onChange={(value) => this.editValue( 'goal', value)}/>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>מה הפרס</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.prizeInEdit.prize}
                                                    style={this.props.prizeInEdit.startDay === '' ? {} : {backgroundColor: '#F0F8FF'}}
                                                    disabled={this.props.prizeInEdit.startDay !== ''}
                                                    onChange={(value) => this.editValue('prize', value)}/>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>הערות</label>
                                    <div className='form__form-group-field'>
                                        <textarea value={this.props.prizeInEdit.comment}
                                                    onChange={(event) => this.editValue('comment', event.target.value)}/>
                                    </div>
                                </div>

                                {/*<div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.email}</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.prizeInEdit.email} noSpace
                                                    onChange={(value) => this.editValue('email', value)}/>
                                    </div>
                                </div>*/}

                                {/*stores.length > 0 && <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>משתמש בחנות</label>
                                    <div className='form__form-group-field'>
                                        <Select
                                            name='select'
                                            value={this.props.prizeInEdit.storeId}
                                            type={"select"}
                                            select
                                            options={stores}
                                            onChange={(value) => this.editValue('storeId', value.value)}
                                        >
                                        </Select>
                                        <span className={`lnr lnr-trash`} onClick={() => this.editValue('storeId', 0)}
                                              style={{cursor: 'pointer', marginTop: '10px', marginLeft: '10px', marginRight: '10px'}} title="Clear"/>
                                    </div>
                                </div>*/}

                            </form>

                            {this.state.error &&
                            <Row>
                                <Alert color='danger' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span>
                                    </p>
                                    <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                                </Alert>
                            </Row>
                            }

                            {this.state.warning !== '' &&
                            <Row>
                                <Alert color='warning' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                    </p>
                                </Alert>
                            </Row>
                            }

                            {!this.state.saving &&
                            <span>
                                <Button color='primary' size='sm'
                                        onClick={() => this.props.onClose()}>{TextManager.getCurrentTextResource().Text.cancel}</Button>
                                < Button color='primary' size='sm'
                                         onClick={() => this.savePrize()}>{TextManager.getCurrentTextResource().Text.save}</Button>
                            </span>
                            }
                            {
                                this.state.saving &&
                                <LoadingProgress/>
                            }
                        </CardBody>
                    </Card>
                </Col>

            </Row>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        prizeInEdit: state.prize.prizeInEdit,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(EditPrizeForm))